import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { injectIntl } from 'react-intl';
import { first, concat } from 'lodash';
import { Alert } from 'react-bootstrap';

import { Modal, Loader } from 'sa-ui';

import messages from './classesStudentsUploadAnswerCardModalMessages';

import './ClassesStudentsUploadAnswerCardModal.scss';

function ClassesStudentsUploadAnswerCardModal({
  isOpen,
  onClose,
  onContinueCallback,
  onUpload,
  isLoading,
  intl,
  correctionFinalized,
  correctionResponse,
  setCorrectionFinalized,
  setCorrectionResponse,
  setLoading,
  resetCorrection,
}) {
  const [isDirty, setIsDirty] = useState(false);
  const [file, setFile] = useState(null);
  const [filesProcessed, setFilesProcessed] = useState(0);

  useEffect(() => {
    if (!isOpen && isDirty) {
      reset();
    }

    if (correctionResponse.success) {
      onContinueCallback();
      setCorrectionFinalized(true);
      setLoading(false);
    }
  }, [
    isOpen,
    isDirty,
    file,
    isLoading,
    correctionResponse,
  ]);

  const reset = () => {
    setIsDirty(false);
    setFile(null);
    resetCorrection();
  };

  const onDrop = useCallback(acceptedFiles => {
    uploadFile(acceptedFiles);
  }, []);
  const { getRootProps } = useDropzone({ onDrop });

  const uploadFile = acceptedFiles => {
    const acceptedFile = first(acceptedFiles);
    setFile(acceptedFile);
    setIsDirty(true);
  };

  const style =
    correctionFinalized && correctionResponse
      ? { color: correctionResponse.success ? 'green' : 'red' }
      : {};

  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      title={'Upload de cartões-resposta'}
      buttons={[
        {
          label: intl.formatMessage(messages.cancel),
          onClick: onClose,
        },
        {
          label: isLoading
            ? 'Por favor, aguarde... [imagem loading]'
            : intl.formatMessage(messages.continue),
          onClick: () => {
            setCorrectionInProgress(true);
            onUpload(file);
          },
          primary: true,
          disabled: isLoading,
        },
      ]}
    >
      <Fragment>
        <div
          {...getRootProps()}
          onClick={() => {
            if (isLoading) return;
            document.getElementById('file').click();
          }}
          style={{ opacity: isLoading ? '0.5' : '1' }}
        >
          <br />
          <i className="icon icon-small ti-cloud-up" />
          <h6 className="subtitle subtitle-bigger mt-2">
            {intl.formatMessage(messages.dragDrop)}
            <br />
            <span>
              <input
                type="file"
                id="file"
                name="file"
                accept=".pdf, image/jpeg"
                style={{ display: 'none' }}
                onChange={e => uploadFile(e.target.files)}
                disabled={isLoading}
              />

              {intl.formatMessage(messages.clickHere)}
            </span>
          </h6>
        </div>
        {/*hasError - broken*/ false && (
          <p style={{ color: '#de120d' }}>
            {` File type not supported. Only .pdf or .jpg files can be uploaded. `}
          </p>
        )}
        {isLoading && <Loader show simple />}
        <div className="reply-cards" style={{ opacity: isLoading ? '0.5' : '1' }}>
          <div className="row">
            <div className="col-md-10 m-auto">
              <div className="row">
                <div className="col-md-12">
                  <div className="col-md-12" style={{ textAlign: 'left' }}>
                    <div className=" reply-cards-unitary">
                      <i className="far fa-file-alt" style={style} />
                      <div className="reply-cards-archive answerCard_tooltip" style={style}>
                        {file && file.name}
                        {correctionFinalized && correctionResponse.error && (
                          <span className="answerCard_tooltiptext">
                            {correctionResponse.message}
                          </span>
                        )}
                      </div>
                      <a
                        onClick={() => {
                          if (isLoading) return;
                          setFile(null);
                        }}
                      >
                        <i className="delete pe-7s-close" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    </Modal>
  );
}

ClassesStudentsUploadAnswerCardModal.defaultProps = {
  correctionResponse: {}
}
export default injectIntl(ClassesStudentsUploadAnswerCardModal);
